import { styled, Typography } from "@mui/material";

export const Container = styled("div")({
  position: "relative",
  margin: ".5rem 0",
  padding: ".8rem 0",
  paddingRight: ".7rem",
  width: "100%",
  borderRadius: "8px",
  backgroundColor: "rgba(0, 0, 0, .04)",
});

export const ReasoningSideLineContainer = styled("div")({
  position: "absolute",
  width: "2px",
  padding: ".8rem 0",
  height: "100%",
  margin: 0,
  top: "50%",
  left: ".5rem",
  transform: "translateY(-50%)",
});

export const StyledReasoningSideLine = styled("div")(({ theme }) => ({
  height: "100%",
  backgroundColor: theme.palette.primary.dark,
}));

export const ReasoningContentContainer = styled("div")({
  whiteSpace: "pre-wrap",
  fontSize: "12px",
  marginLeft: "1.2rem",
});

export const StyledTypography = styled(Typography)(({ theme }) => ({
  color: theme.palette.primary.darkest,
  fontStyle: "italic",
}));
